
export const config = {
  id: 'cartoonish',
  name: 'Cartoonish',
  icon: 'laugh-beam',
  color: 'pink',
  welcomeMessage: "This is a message from the bot.",
  typography: "'Comic Neue', cursive",
  description: 'A cartoonish visual style.',
  preview: 'This is a message from the user.jaghhaha',
  suggestedPrompts: [
    { text: 'Tell me a funny story! 🤪' },
    { text: 'What\'s your favorite color? 🎨' },
    { text: 'Can you do a trick? 🪄' },
  ],
  animation: {
    messageIn: 'pop-in',
    messageOut: 'pop-out',
    typing: 'cartoon-bounce',
    avatar: 'cartoon-bounce',
    button: 'wiggle',
    shinchan: true,
    balloons: true
  },
  transitions: {
    duration: '0.5s',
    timing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    hover: '0.3s ease-in-out'
  },
  effects: {
    bounce: true,
    rotate: true,
    shadow: 'lg',
    hover: 'scale(1.1) rotate(5deg)',
    focus: 'ring-2 ring-pink-400',
    active: 'scale-95'
  },
  embedCode: `<script src="chatbot-loader.js"></script>
<script>
window.chatConfig = {
  theme: "cartoonish",
  color: "#EC4899",
  typography: "Comic Neue, cursive",
  welcomeMessage: "Hey there! 👋 I'm your friendly cartoon buddy!",
  userId: "user_cartoon_123",
  chatbotId: "bot_cartoon_001",
  animations: {
    enabled: true,
    duration: "0.5s",
    effects: {
      bounce: true,
      rotate: true,
      shinchan: true,
      balloons: true
    }
  }
};
</script>`
}; 